import { isProductionDomain, isStagingDomain } from "./configUtil";

let expressServerPort = process.env.REACT_APP_EXPRESS_SERVER_PORT;
// Set the express server base URL
let expressServerBaseUrl = "";
// If this is not the production environment then set the base URL to point to the express server
if(process.env.NODE_ENV !== "production" ) {
    expressServerBaseUrl = `http://localhost:${expressServerPort}`;
}

/**
 * Creates the correct server URL depending on the environment that the application is running in
 * @param uri the URI to append to the server base URL
 * @returns server URL with the value of the uri parameter added to it
 */
function createServerUrl(uri) {
    return expressServerBaseUrl + uri;
}

function createCloudCmsApiPageContentUrl() {
    return createServerUrl("/api/cloud-cms-api/page-content");
}

function createCloudCmsApiVersionedPageContentUrl() {
    return createServerUrl("/api/cloud-cms-api/versioned-page-content");
}


/**
 * Get the Google Tag Manager ID
 * @returns the Google Tag Manager ID
 */
function getGoogleTagManagerId() {
    return isProductionDomain() ? process.env.REACT_APP_PROD_GTM_ID : process.env.REACT_APP_GTM_ID;
}
export let googleTagManagerId = getGoogleTagManagerId();

function getFogotPasswordLink() {
    return isProductionDomain() ? process.env.REACT_APP_PROD_FORGOT_PASSWORD_LINK: process.env.REACT_APP_FORGOT_PASSWORD_LINK;
}
export let fogotPasswordLink = getFogotPasswordLink();

function getServiceAccountEnvironmentId() {
    return isProductionDomain() ? process.env.REACT_APP_PROD_SERVICE_ACCOUNT_ENVIRONMENT_ID: process.env.REACT_APP_SERVICE_ACCOUNT_ENVIRONMENT_ID;
}
export let serviceAccountEnvironment = getServiceAccountEnvironmentId();

function getBusinessEmailAddress() {
    return isProductionDomain() ? process.env.REACT_APP_PROD_BUSINESS_EMAIL_ADDRESS: process.env.REACT_APP_BUSINESS_EMAIL_ADDRESS;
}
export let businessEmailAddress = getBusinessEmailAddress();
/**
 * Show and Hide Request Access Link based on Production/Staging flags. 
 */
function showRequestAccessLink(){
    if(isProductionDomain()){
        return process.env.REACT_APP_PROD_API_ACCESS_REQUEST_LINK;
    }
    if(isStagingDomain()){
       return process.env.REACT_APP_API_ACCESS_REQUEST_LINK;
    }
    return true;
}
/**
 * Get the React app Mask Flag
 * @returns the React app Mask Flag
 */
function getMaskFlag() {
    return isProductionDomain() ? process.env.REACT_APP_PROD_MASK_FLAG: (isStagingDomain () ? process.env.REACT_APP_STG_MASK_FLAG:process.env.REACT_APP_MASK_FLAG);
}
export let maskFlag = getMaskFlag();

/**
 * Get the React app Terms And Agreement Version
 * @returns the React app Terms And Agreement Version
 */
function getTermsAndAgreementVersion() {
    return isProductionDomain() ? process.env.REACT_APP_PROD_TERMS_AND_AGREEMENT_VERSION: (isStagingDomain () ? process.env.REACT_APP_STG_TERMS_AND_AGREEMENT_VERSION:process.env.REACT_APP_TERMS_AND_AGREEMENT_VERSION);
}
export let termsAndAgreementVersion = getTermsAndAgreementVersion();

/**
 * Get the React app CNA company ID
 * @returns the React app CNA company ID
 */
function getCnaCompnayId() {
    return isProductionDomain() ? process.env.REACT_APP_PROD_CNA_COMPANY_ID: (isStagingDomain () ? process.env.REACT_APP_STG_CNA_COMPANY_ID:process.env.REACT_APP_CNA_COMPANY_ID);
}
export let cnaCompanyId = getCnaCompnayId();

/**
 * Get the React app GROUP NAME PREFIX
 * @returns the React app GROUP NAME PREFIX
 */
 function getGroupNameEnv() {
    return isProductionDomain() ? "": (isStagingDomain () ? process.env.REACT_APP_STG_GROUP_NAME_PREFIX + ".":process.env.REACT_APP_GROUP_NAME_PREFIX+ ".");
}
export let groupNameEnv = getGroupNameEnv();

export { 
    createServerUrl, 
    createCloudCmsApiPageContentUrl,
    createCloudCmsApiVersionedPageContentUrl,
    showRequestAccessLink
};